/**
 * getFactInfos接口的Mock数据
 * 基于API文档和代码使用情况生成
 */

export const mockFactInfosResponse = {
  code: 200,
  message: 'success',
  data: [
    {
      factCode: 'SALES_FACT',
      factName: '销售事实表'
    },
    {
      factCode: 'ORDER_FACT', 
      factName: '订单事实表'
    },
    {
      factCode: 'USER_BEHAVIOR_FACT',
      factName: '用户行为事实表'
    }
  ]
}

/**
 * 用于测试的简化版本
 */
export const mockFactInfosSimple = [
  {
    factCode: 'SALES_FACT',
    factName: '销售事实表'
  },
  {
    factCode: 'ORDER_FACT',
    factName: '订单事实表'
  },
  {
    factCode: 'USER_BEHAVIOR_FACT',
    factName: '用户行为事实表'
  }
]

/**
 * 在cubeQuery.vue中使用的格式
 * 经过map转换后的数据结构
 */
export const mockFactInfosMapped = mockFactInfosResponse.data.map((v) => {
  return {
    ...v,
    id: v.factCode,
    label: v.factName,
  }
})

/**
 * 模拟getFactInfos接口调用
 * 可以直接替换原有的接口调用
 */
export const mockGetFactInfos = async (params = {}, options = {}) => {
  // 模拟网络延迟
  await new Promise(resolve => setTimeout(resolve, 300))
  
  return {
    data: mockFactInfosResponse.data
  }
}
